import { defineComponent as _defineComponent } from 'vue'
import { ref } from "../../../../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-text',
  props: {
  content: {
    type: Array,
    default: [],
  },
  highlightType: {
    type: String,
    default: "font", // "font":字体高亮 "background":背景高亮
  },
  displayType: {
    type: String,
    default: "info", // "info":信息展示形式 "bubble": 气泡展示形式
  },
},
  setup(__props) {

const props = __props


const contentText = ref<Array<{ text: string; isHighlight: boolean }>>(props.content);

return { __sfc: true,props, contentText }
}

})